import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.scss'],
  standalone: false,
})
export class UserGuideComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
